import { TextWithDropShadow } from '../TextWithDropShadow';
import Heading from '../common/Heading';
import IconComponent from '../FlashCards/Icon';
import Image from 'next/image';

export interface StrapiFlatReviewData {
  blockCopyColor: string;
  cardBGColor: string;
  content: string;
  hidden: boolean;
  icon: {
    name: string;
  };
  iconURL: string;
  iconBGColor: string;
  iconColor: string;
  id: number;
  maxWidth: string;
  orientation: string;
  cardTitle: {
    text: string;
    shadow: boolean;
    hidden: boolean;
    size: {
      size: string;
    };
    color: {
      color: string;
    };
  };
}
export default function ReviewCard({
  reviewBlock,
}: {
  reviewBlock: StrapiFlatReviewData;
}) {
  const titleSize =
    (reviewBlock.cardTitle &&
      reviewBlock.cardTitle?.size?.size.match(/\d+/)?.[0]) ||
    '5';
  return (
    <div
      className={`flex w-full justify-start gap-x-6 gap-y-4 rounded-2xl bg-[${reviewBlock.cardBGColor || '#F4F6F8'}] p-9 ${reviewBlock.maxWidth || 'max-w-3xl'} ${reviewBlock.orientation === 'horizonal' ? 'flex-row' : 'flex-col'}`}
    >
      <div
        style={{ background: `${reviewBlock.iconBGColor || '#1C8EFF'}` }}
        className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full p-2 text-base font-medium'
      >
        {reviewBlock.iconURL ? (
          <Image
            src={reviewBlock.iconURL}
            alt='Card Icon'
            width={20}
            height={20}
          />
        ) : (
          <IconComponent
            name={reviewBlock.icon?.name}
            fill={reviewBlock.iconColor || '#FFFFFF'}
            className='size-5'
          />
        )}
      </div>
      <div>
        {!reviewBlock.cardTitle?.hidden && (
          <Heading className='mb-3' size={`${titleSize}`}>
            <TextWithDropShadow
              text={reviewBlock.cardTitle?.text}
              color={{
                text: reviewBlock.cardTitle?.color?.color || 'text-grey-900',
                shadow: '',
              }}
              displayShadow={false}
            />
          </Heading>
        )}
        <div className='text-base font-medium'>
          <TextWithDropShadow
            text={reviewBlock.content}
            displayShadow={false}
            color={{ text: reviewBlock.blockCopyColor, shadow: '' }}
          />
        </div>
      </div>
    </div>
  );
}
